<!--
  Relative asset URLs on purpose. The browser resolves them against the
  document's <base href>, so the same markup finds '/assets/img/…' in a
  deployment served from the root and '/<prefix>/assets/img/…' in one served
  under a path prefix. A component stylesheet's url() cannot do that — it is
  resolved at build time, against a file that does not exist in the library.
-->
<div
  class="kf-signin"
  [style.background-image]="app.signInBackgroundUrl ? 'url(' + app.signInBackgroundUrl + ')' : null"
>
  <div class="kf-signin-card">
    @if (app.signInLogoUrl) {
      <div class="kf-signin-logo">
        <img [src]="app.signInLogoUrl" [alt]="app.appName" />
      </div>
    }

    <div class="kf-signin-lede">
      <h1>{{ app.appName }}</h1>
      <p>Advance ERP Software Solution for Manufacturing Industry with IoT Features</p>
    </div>

    <button nz-button nzType="primary" nzSize="large" nzBlock class="kf-signin-button" (click)="signIn()">
      <span nz-icon nzType="login" nzTheme="outline"></span>
      Log in with Single Sign On
    </button>

    <div class="kf-signin-footer">
      <p>
        &copy; {{ year }}
        <a href="https://www.misayinnovations.com" target="_blank" rel="noopener noreferrer">Misay Innovations Pvt. Ltd.</a>
        All rights reserved.
      </p>
    </div>
  </div>
</div>
